import { Controller } from "@hotwired/stimulus"

// data-controller="user_menu"
export default class extends Controller {
    static targets = ["popover"]

    toggle(e) {
        if (e) e.preventDefault()
        if (!this.hasPopoverTarget) return

        const el = this.popoverTarget
        if (el.hasAttribute("hidden")) {
            el.removeAttribute("hidden")
            // Close on click outside
            setTimeout(() => {
                document.addEventListener("click", this.closeOnClickOutside.bind(this), { once: true })
            }, 10)
        } else {
            el.setAttribute("hidden", "")
        }
    }

    closeOnClickOutside(event) {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    close() {
        if (this.hasPopoverTarget) this.popoverTarget.setAttribute("hidden", "")
    }

    triggerKey(e) {
        if (e.key === "Enter" || e.key === " ") this.toggle(e)
        if (e.key === "Escape") this.close()
    }
}
